// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"right_section-module__wrapper___o8unH","main":"right_section-module__main___dmWey"};